export const ErrorMessages = Object.freeze({
	'NETWORK_ERROR': 'We are having trouble reaching the server right now... We’re working on it.... Please refresh your page!',
	'CONTACT_US': 'Sorry, there seems to be a problem. Please refresh and try again. If the problem persists please contact us.'
})